import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class NumberingLogic<T extends EMode = EMode.entity> {
  /** Alias: objType */
  id?: number;
  /** Alias: ersteNummer */
  firstNumber?: number;
  /** Alias: letzteNummer */
  lastNumber?: number;
  /** Alias: step */
  step?: number;

  __typename?: string;
}

const fields: FieldDefinitions<NumberingLogic> = {
  id: {
    alias: 'objType',
  },
  firstNumber: {
    alias: 'ersteNummer',
  },
  lastNumber: {
    alias: 'letzteNummer',
  },
  step: {
    alias: 'step',
  },
  __typename: {
    alias: '__typename',
  },
};

export const numberingLogicEntityDefinition: EntitiyDefinition<NumberingLogic> =
  {
    local: {},
    remote: {
      queryName: 'getNumberRules',
      fragmentName: 'Nummernkreis',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'upsertNumberRule',
          args: [
            { name: 'input', type: 'InputNummernkreis!' },
            { name: 'drySave', type: 'Boolean' },
          ],
        },
      },
    },
    fieldDefinitions: fields,
  };
